import React, { FunctionComponent } from 'react';

import Avatar from '@justgiving/avatar';

import { PageOwnerAvatarQuery } from '../../../types/__generated__';
import { LOGO } from '../../constants/imageTemplateStrings';
import useFullPageQuery from '../../hooks/useFullPageQuery';
import { makePhotoUrlFromAbsoluteUrl } from '../../utils/makePhotoUrl';
import query from '../PageOwnerAvatar/PageOwnerAvatar.gql';

import styles from './CompactPageOwnerAvatar.scss';

export const CompactPageOwnerAvatar: FunctionComponent = () => {
  const { data } = useFullPageQuery<PageOwnerAvatarQuery>(query);

  if (!data?.page) return null;

  const { owner, logo } = data.page;

  if (owner?.avatar) {
    return (
      <div className={styles.image}>
        <Avatar
          picture={
            (owner &&
              owner.avatar &&
              makePhotoUrlFromAbsoluteUrl(owner.avatar)) ||
            ''
          }
          avatarSize="large"
          hasBorder
        />
      </div>
    );
  }

  if (logo) {
    return (
      <div className={styles.logoWrapper}>
        <img
          className={styles.logoImage}
          src={makePhotoUrlFromAbsoluteUrl(logo, LOGO)}
          alt=""
          data-qa="stickySummary-pageLogo"
        />
      </div>
    );
  }

  return null;
};
